export const FrontRoutes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "layout" */ `@/views/front/FrontLayout`),
    meta: {
      auth: true,
    },
    children: [
      {
        path: "/404",
        name: "error",
        component: () =>
          import(
            /* webpackChunkName: "alerts" */ "@/components/front/errorPage.vue"
          ),
      },
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ `@/views/front/home/Dashboard`),
        meta: {
          auth: true,
        },
      },
      // {
      //   path: "/boe-outbound",
      //   name: "BoeOutbound",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "boe outbound" */ "@/views/front/boe-outbound/Index"
      //     ),
      //   meta: {
      //     auth: true,
      //     breadcrums: [
      //       {
      //         text: "BOE Outbound",
      //       },
      //     ],
      //     ref: "#86",
      //   },
      // },
      {
        path: "/upload-billing",
        name: "BillingData",
        component: () => import("@/components/front/billing/upload"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Billing",
              to: "BillingDataList",
            },
            {
              text: "Upload",
            },
          ],
          permissionKey:
            "app_carrier_partner:carrier_consignment_billing_upload",
        },
      },
      {
        path: "/pending-billing",
        name: "PendingBilling",
        component: () => import("@/components/front/billing/pending"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Billing",
              to: "BillingDataList",
            },
            {
              text: "Billing Pending Summary",
            },
          ],
          permissionKey: "app_carrier_partner:billing_pending_summary_list",
        },
      },
      {
        path: "/pending-billing-list",
        name: "PendingBillingList",
        component: () =>
          import("@/components/front/billing/pendingBillingAction"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Billing",
            },
            {
              text: "Billing Pending Summary",
              to: "PendingBilling",
            },
            {
              text: "Pending list",
            },
          ],
          permissionKey: "app_carrier_partner:lastmile_pending_order_list",
        },
      },
      {
        path: "/billing-data",
        name: "BillingDataList",
        component: () => import("@/components/front/billing/data"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Billing",
            },
            {
              text: "Billing Data",
            },
          ],
          permissionKey: "app_carrier_partner:consignment_billing_done_list",
        },
      },
      {
        path: "/cod-pending-payment",
        name: "PendingCod",
        component: () => import("@/components/front/cod/PendingCod"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "COD Reconciliation",
            },
            {
              text: "COD Payment Pending",
            },
          ],
          permissionKey: "app_cod_reconcile:cod-payment-pending-list",
        },
      },
      {
        path: "/cod-paid-payment",
        name: "PaidCod",
        component: () => import("@/components/front/cod/PaidCod"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "COD Reconciliation",
            },
            {
              text: "COD Paid payment",
            },
          ],
          permissionKey: "app_cod_reconcile:cod_payment_paid_summary_list",
        },
      },
      {
        path: "/pending-orders",
        name: "PendingOrderList",
        component: () => import("@/components/front/cod/PendingActionList"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "COD Reconciliation",
            },
            {
              text: "COD Payment Details",
            },
            {
              text: "Orders list",
            },
          ],
        },
      },

      {
        path: "/cod-disputed-payment",
        name: "DisputedCod",
        component: () => import("@/components/front/cod/DisputedCod"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "COD Reconciliation",
            },
            {
              text: "COD Payment Disputed",
            },
          ],
          permissionKey: "app_cod_reconcile:cod-disputed-order",
        },
      },
      {
        path: "/reconciliation-pending",
        name: "ReconciliationCod",
        component: () => import("@/components/front/cod/ReconciliationCod"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "COD Reconciliation",
            },
            {
              text: "Reconciliation Pending",
            },
          ],
          permissionKey: "app_cod_reconcile:cod-pending-order-list",
        },
      },
      {
        path: "/cod",
        component: () => import("@/views/front/cod/CodIndex"),
        children: [
          {
            path: "carrier",
            component: () => import("@/components/front/cod/CarrierCod"),
            name: "CarrierCod",
            meta: {
              breadcrums: [
                {
                  text: "Lastmile Delivery",
                },
                {
                  text: "COD Reconciliation",
                },
              ],
              permissionKey: "app_cod_reconcile:carrier-cod-payment_list",
            },
          },
          {
            path: "rsa",
            component: () => import("@/components/front/cod/RsaCod"),
            name: "RsaCod",
            meta: {
              breadcrums: [
                {
                  text: "Lastmile Delivery",
                },
                {
                  text: "COD Reconciliation",
                },
              ],
            },
          },
        ],
      },
      {
        path: "/add-inbound-order",
        name: "AddInboundOrder",
        component: () =>
          import(
            /* webpackChunkName: "AddInboundOrder" */ `@/views/front/inbound/Add`
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inbound Orders",
            },
            {
              text: "Add",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_po_upload",
        },
      },
      {
        path: "/list-inbound-order",
        name: "ListInboundOrder",
        component: () =>
          import(
            /* webpackChunkName: "ListInboundOrder" */ `@/views/front/inbound/List`
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inbound Orders",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_po_list",
        },
      },

      {
        path: "/vendor/add-vendor/:id",
        name: "Addvendor",
        component: () =>
          import(
            /* webpackChunkName: "AddInboundOrder" */ `@/views/front/vendor/add`
          ),
        meta: {
          breadcrums: [
            {
              text: "Vendor",
              to: "Listvendor",
            },
            {
              text: "Add/Edit",
            },
          ],
          permissionKey: "app_osl_overtime_cost:add_vendor",
        },
      },
      {
        path: "/vendor/list",
        name: "Listvendor",
        component: () =>
          import(
            /* webpackChunkName: "AddInboundOrder" */ `@/views/front/vendor/list`
          ),
        meta: {
          breadcrums: [
            {
              text: "Vendor",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_osl_overtime_cost:list_vendor",
        },
      },
      {
        path: "/vendor/rateCard/:id",
        name: "Addratecard",
        component: () =>
          import(
            /* webpackChunkName: "AddInboundOrder" */ `@/views/front/vendor/AddRate`
          ),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "Rate Card",
              to: "ListvendorRateCard",
            },
            {
              text: "Add/Edit",
            },
          ],
          permissionKey: "app_osl_overtime_cost:add_rate_card",
        },
      },
      {
        path: "/vendor/timesheet",
        name: "AddTimesheet",
        component: () => import(`@/views/front/vendor/AddTimesheet`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "Timesheet",
              to: "TimesheetList",
            },
            {
              text: "Upload",
            },
          ],
          permissionKey: "app_osl_overtime_cost:request_application_upload",
        },
      },
      {
        path: "/vendor/timesheet-list",
        name: "TimesheetList",
        component: () => import(`@/views/front/vendor/ListTimesheet`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "Timesheet",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_osl_overtime_cost:request_application_list",
        },
      },
      {
        path: "/vendor/timesheet-summary",
        name: "timesheetSummary",
        component: () => import(`@/views/front/vendor/SummaryTimesheet`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "Timesheet",
            },
            {
              text: "Timesheet Summary",
            },
          ],
          permissionKey: "app_osl_overtime_cost:osl_summary_month_wise_list",
        },
      },
      {
        path: "/vendor/date-timesheet-summary",
        name: "timesheetSummaryDetails",
        component: () => import(`@/views/front/vendor/summaryDetails`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "Timesheet",
            },
            {
              text: "Summary",
            },
          ],
          permissionKey: "app_osl_overtime_cost:osl_summary_date_wise_list",
        },
      },
      {
        path: "/vendor/attendance-list",
        name: "attendanceList",
        component: () => import(`@/views/front/vendor/AttendenceList`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },

            {
              text: "attendance",
            },
          ],
          permissionKey:
            "app_osl_overtime_cost:vendor_employee_attendance_list",
        },
      },

      {
        path: "/vendor/rateCardList",
        name: "ListvendorRateCard",
        component: () => import(`@/views/front/vendor/rateCardList`),
        meta: {
          breadcrums: [
            {
              text: "Overtime",
            },
            {
              text: "RateCard",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_osl_overtime_cost:list_rate_card",
        },
      },

      {
        path: "/upload-product",
        name: "UploadProduct",
        component: () => import(`@/views/front/product/Upload`),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Product/ASN",
            },
            {
              text: "Upload Product",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_sku_import",
        },
      },
      {
        path: "/product-list",
        name: "ProductList",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/product/List`
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Product/ASN",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_sku_list",
        },
      },
      {
        path: "/sku-list",
        name: "SkuList",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/product/SkuList`
          ),
        meta: {
          breadcrums: [
            {
              text: "Product/ASN",
            },
            {
              text: "SKU List",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_skus",
        },
      },
      {
        path: "/supplier",
        name: "AddSupplier",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/supplier/Add`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Supplier",
              to: "MappedSupplierList",
            },
            {
              text: "Add/Edit",
            },
          ],
          permissionKey: "app_infor:b2b_create_supplier_mapping",
        },
      },

      {
        path: "/supplier-list",
        name: "SupplierList",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/supplier/List`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Supplier",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_infor:b2b_supplier_list",
        },
      },
      {
        path: "/mapped-supplier-list",
        name: "MappedSupplierList",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/supplier/MappedList`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Supplier",
            },
            {
              text: "Mapped Supplier List",
            },
          ],
          permissionKey: "app_infor:b2b_supplier_mapping_list",
        },
      },
      {
        path: "/clientApi",
        name: "ApiResponse",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/ClientApi`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },

            {
              text: "Client Api Response",
            },
          ],
          permissionKey: "app_infor:client_api_pending_summary",
        },
      },
      {
        path: "/clientApiSummary",
        name: "ApiResponsePending",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/ClientApiSummary`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },

            {
              text: "Client Api Summary",
            },
          ],
          permissionKey: "app_infor:client_api_failed_transactions",
        },
      },
      {
        path: "/clientClosedTransaction",
        name: "ApiResponseClosed",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/ClientClosedTransaction`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },

            {
              text: "Client Closed Transaction",
            },
          ],
          permissionKey: "app_infor:client_api_failed_transactions",
        },
      },
      {
        path: "/boe-outbound",
        component: () =>
          import(
            /* webpackChunkName: "boe-outbound" */ "@/views/front/boe-outbound/Index"
          ),
        children: [
          {
            path: "local",
            component: () =>
              import(
                /* webpackChunkName: "local-boe-outbound" */ "@/components/front/boe-outbound/LocalBoeOutbound"
              ),
            name: "LocalBoeOutbound",
            meta: {
              breadcrums: [
                {
                  text: "Fulfillment",
                },
                {
                  text: "Local Boe Outbound",
                },
              ],
              permissionKey: "app_ecom_vendors:boe_outbound_list_local",
            },
          },
          {
            path: "international",
            component: () =>
              import(
                /* webpackChunkName: "international-boe-outbound" */ "@/components/front/boe-outbound/InternationalBoeOutbound"
              ),
            name: "InternationalBoeOutbound",
            meta: {
              breadcrums: [
                {
                  text: "Fulfillment",
                },
                {
                  text: "International Boe Outbound",
                },
              ],
            },
          },
        ],
      },
      {
        path: "/help",
        name: "Help",
        component: () =>
          import(/* webpackChunkName: "help" */ "@/views/front/help/Index"),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "Help Section",
            },
          ],
          permissionKey: "help",
        },
      },
      {
        path: "/dashboards-reports",
        name: "DashBoardsReports",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-reports" */ `@/views/front/dashboards/Index`
          ),
        meta: {
          breadcrums: [
            {
              text: "Dashboard & Reports",
            },
          ],

          permissionKey:
            "app_dashboard_report:dashboard_report_list_list_create",
        },
      },
      {
        path: "/dashboards-pas",
        name: "PasDashBoards",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-pas" */ `@/views/front/dashboards/Pas`
          ),
        meta: {
          breadcrums: [
            {
              text: "Pas Dashboard",
            },
          ],

          permissionKey: "app_pas:pas_report_dashboard",
        },
      },
      {
        path: "/dashboards-reports/:id",
        name: "DashBoardsReportsDetails",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-reports-details" */ `@/views/front/dashboards/Details`
          ),
        meta: {
          breadcrums: [
            {
              text: "Dashboard & Reports",
              to: "DashBoardsReports",
            },
            {
              text: "Add or Edit",
            },
          ],
        },
      },
      {
        path: "/dashboards-reports/preview/:id",
        name: "DashBoardsReportsPreview",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-reports-details" */ `@/views/front/dashboards/Preview`
          ),
        meta: {
          breadcrums: [
            {
              text: "Dashboard & Reports",
              to: "DashBoardsReports",
            },
            {
              text: "Preview",
            },
          ],
        },
      },
      {
        path: "/rulesAllocation",
        name: "Linehaul",
        component: () =>
          import(
            /* webpackChunkName: "linehaul" */ "@/views/front/linehaul/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Allocation Rules",
            },
          ],
          permissionKey: "app_linehaul:linehaul_list",
        },
      },
      {
        path: "/rulesAllocation/add/:id",
        name: "LinehaulAdd",
        component: () =>
          import(
            /* webpackChunkName: "linehaul-edit" */ "@/views/front/linehaul/Add"
          ),
        meta: {
          breadcrums: [
            {
              text: "Allocation Rules",
              to: "Linehaul",
            },
            {
              text: "Add",
            },
          ],
        },
      },
      {
        path: "/rulesAllocation/edit/:id",
        name: "LinehaulEdit",
        component: () =>
          import(
            /* webpackChunkName: "linehaul-edit" */ "@/views/front/linehaul/Edit"
          ),
        meta: {
          breadcrums: [
            {
              text: "Allocation Rules",
              to: "Linehaul",
            },
            {
              text: "Edit",
            },
          ],
        },
      },
      {
        path: "/carriers",
        name: "Carriers",
        component: () =>
          import(
            /* webpackChunkName: "carriers" */ "@/views/front/carriers/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
            },
            {
              text: "List of Carriers",
            },
          ],
          permissionKey: "app_carrier_partner:carrier_list",
        },
      },

      {
        path: "/carriers/add/:id",
        name: "carrierDetails",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-reports-details" */ `@/views/front/carriers/Details`
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "Add or Edit",
            },
          ],
        },
      },
      {
        path: "/carriers-addresses",
        name: "CarriersAddresses",
        component: () =>
          import(
            /* webpackChunkName: "carriers" */ "@/views/front/carriers/address.vue"
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "List of Address(es)",
            },
          ],
          permissionKey: "app_carrier_partner:carrier_address_list",
        },
      },
      {
        path: "/carriers-tracking",
        name: "CarrierList",
        component: () =>
          import(
            /* webpackChunkName: "carriers" */ "@/views/front/carriers/tracking.vue"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile delivery",
            },
            {
              text: "Delay in Carrier Tracking Update",
            },
          ],
          permissionKey: "app_carrier_partner:carrier_event_update_tracking",
        },
      },
      // {
      //   path: "/carriers/edit/:id",
      //   name: "CarrierEdit",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "carriers-edit" */ "@/views/front/carriers/Edit"
      //     ),
      //   meta: {
      //     breadcrums: [
      //       {
      //         text: "Carriers",
      //         to: "Carriers",
      //       },
      //       {
      //         text: "Edit",
      //       },
      //     ],
      //     ref: "#4",
      //   },
      // },
      {
        path: "/carriers/events-upload",
        name: "CarrierEventsUpload",
        component: () =>
          import(
            /* webpackChunkName: "carriers-edit" */ "@/views/front/carriers/EventsUpload"
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "Carrier Tracking Events",
            },
          ],
          permissionKey: "app_carrier_partner:tracking-events-list",
        },
      },
      {
        path: "/country-upload",
        name: "CountryUpload",
        component: () =>
          import(
            /* webpackChunkName: "carriers-edit" */ "@/views/front/carriers/CountryCityUpload"
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "Carrier Coverage Upload",
            },
          ],
          permissionKey: "app_carrier_partner:carrier-country-list",
        },
      },
      {
        path: "/carrier-services",
        name: "CarriersServices",
        component: () => import("@/views/front/carriers/Services"),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
            },
            {
              text: "Carrier Services",
            },
          ],
          permissionKey: "app_service_type:carrier_service_types_list",
        },
      },
      {
        path: "/carrier-services/:id",
        name: "AddCarriersServices",
        component: () => import("@/views/front/carriers/AddServices"),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
            },
            {
              text: "Carrier Services",
              to: "CarriersServices",
            },
            {
              text: "Add/Edit",
            },
          ],
          permissionKey: "app_service_type:add_carrier_service_types",
        },
      },
      {
        path: "/city-upload",
        name: "CityUpload",
        component: () =>
          import(
            /* webpackChunkName: "carriers-edit" */ "@/views/front/carriers/CityUpload"
          ),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "Carrier City Upload",
            },
          ],
        },
      },
      {
        path: "bag-labels",
        component: () =>
          import(
            /* webpackChunkName: "bag-label" */ "@/views/front/labels/Bags"
          ),
        name: "BagLabels",
        meta: {
          breadcrums: [
            {
              text: "Label",
              to: "BagLabels",
            },
            {
              text: "Download",
            },
          ],
        },
      },
      {
        path: "package-labels",
        component: () =>
          import(
            /* webpackChunkName: "package-label" */ "@/views/front/labels/Packages"
          ),
        name: "PackageLabels",
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Download Label",
            },
          ],
          permissionKey: "app_consignment_order:package_multiple_label_list",
        },
      },
      {
        path: "shipping-invoice",
        component: () =>
          import(
            /* webpackChunkName: "package-label" */ "@/views/front/labels/Invoice"
          ),
        name: "InvoiceLabels",
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Download Invoice",
            },
          ],
          permissionKey:
            "app_consignment_order:multiple_download_shipping_invoices",
        },
      },
      {
        path: "/handling-codes",
        name: "SpHandlingCodes",
        component: () =>
          import(
            /* webpackChunkName: "handling-codes" */ "@/views/front/handling-codes/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Special Handling Codes",
            },
          ],
        },
      },
      {
        path: "/split-codes",
        name: "SplitCodes",
        component: () =>
          import(
            /* webpackChunkName: "split-codes" */ "@/views/front/split-codes/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Split Codes",
            },
          ],
        },
      },
      {
        path: "/split-codes/:id",
        name: "SplitCodeDetails",
        component: () =>
          import(
            /* webpackChunkName: "split-codes-details" */ "@/views/front/split-codes/Details"
          ),
        meta: {
          breadcrums: [
            {
              text: "Split Creation",
            },
          ],
        },
      },
      {
        path: "manifests",
        component: () =>
          import(
            /* webpackChunkName: "manifests" */ "@/views/front/manifests/Index"
          ),
        children: [
          {
            path: "",
            component: () =>
              import(
                /* webpackChunkName: "manifests-list" */ "@/components/front/manifests/List"
              ),
            name: "ManifestsList",
            meta: {
              breadcrums: [
                {
                  text: "Lastmile Delivery",
                },
                {
                  text: "Manifests",
                },
              ],
            },
          },
          {
            path: "manifests-template",
            component: () =>
              import(
                /* webpackChunkName: "manifests-template" */ "@/components/front/manifests/Template"
              ),
            name: "ManifestsTemplate",
            meta: {
              breadcrums: [
                {
                  text: "Manifests",
                  to: "ManifestsList",
                },
                {
                  text: "Explain Template",
                },
              ],
            },
          },
        ],
      },
      {
        path: "/tracking-events",
        name: "TrackingEvents",
        component: () =>
          import(
            /* webpackChunkName: "tracking-events" */ "@/views/front/tracking-events/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "RSA Tracking Events",
            },
          ],
          permissionKey: "tracking-event-list",
        },
      },
      {
        path: "/tracking/details",
        name: "TrackingDetails",
        component: () =>
          import(
            /* webpackChunkName: "tracking-events" */ "@/views/front/TrackingDetails"
          ),
        meta: {
          breadcrums: [
            {
              text: "Package Details",
              to: "PackageDetails",
            },
            {
              text: "Details",
            },
          ],
        },
      },
      {
        path: "/entity-scans",
        name: "EntityScans",
        component: () =>
          import(
            /* webpackChunkName: "entity-scans" */ "@/views/front/entity-scans/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Entity Scans",
            },
          ],
        },
      },
      {
        path: "/package-details",
        name: "PackageDetails",
        component: () =>
          import(
            /* webpackChunkName: "order-details" */ "@/views/front/order-details/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Package Details",
            },
          ],
          permissionKey: "app_consignment_order:order_details",
        },
      },
      {
        path: "/clients",
        name: "Clients",
        component: () =>
          import(
            /* webpackChunkName: "clients" */ "@/views/front/clients/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
            },
            {
              text: "List of Clients",
            },
          ],
          permissionKey: "app_client:client_list",
        },
      },
      {
        path: "/clients/add/:id",
        name: "clientDetails",
        component: () =>
          import(
            /* webpackChunkName: "dashboards-reports-details" */ `@/views/front/clients/Details`
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "Add or Edit",
            },
          ],
        },
      },
      {
        path: "/clients/product-hscode",
        name: "ProductHSCodeMap",
        component: () =>
          import(
            /* webpackChunkName: "clients-product-hscodes" */ "@/views/front/clients/ProductHSCodeMap"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "Mapping of Product Code",
            },
          ],
          permissionKey: "product-hs-codes",
        },
      },
      {
        path: "/clients/product-hscode",
        name: "ProductHSCode",
        component: () =>
          import(
            /* webpackChunkName: "clients-product-hscodes" */ "@/views/front/clients/ProductHSCodeMap"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "ProductCode-HSCode",
            },
          ],
          permissionKey: "app_seller:products_verify_upload",
        },
      },
      {
        path: "/clients/map-sellers",
        name: "MapSellers",
        component: () =>
          import(
            /* webpackChunkName: "clients-map-sellers" */ "@/views/front/clients/MapSellers"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "List of Sellers Mapped",
            },
          ],
          permissionKey: "app_seller:mapped_seller_list",
        },
      },
      {
        path: "/seller-onboarding-status",
        component: () =>
          import(
            /* webpackChunkName: "seller-onboarding-status" */ "@/components/front/sellers/SellerOnboardingStatus"
          ),
        name: "SellerOnboardingStatus",
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Seller Onboarding Status",
            },
          ],
          permissionKey: "app_seller:seller-pending-status-upload",
        },
      },
      {
        path: "/invoices",
        name: "Invoices",
        component: () =>
          import(
            /* webpackChunkName: "invoices-counts" */ "@/views/front/invoices/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "IOR Package",
            },
          ],
          permissionKey: "app_seller:client_invoice_count",
        },
      },
      {
        path: "/client-invoices",
        name: "ClientInvoices",
        component: () =>
          import(
            /* webpackChunkName: "invoices" */ "@/views/front/invoices/ClientInvoices"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Package",
              to: "Invoices",
            },
            {
              text: "Client",
            },
          ],
        },
      },
      {
        path: "/invoices/add",
        name: "InvoiceAdd",
        component: () =>
          import(
            /* webpackChunkName: "invoices-add" */ "@/views/front/invoices/Add"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Package",
              to: "Invoices",
            },
            {
              text: "Add",
            },
          ],
        },
      },
      {
        path: "/invoices/:id",
        name: "InvoiceEdit",
        component: () =>
          import(
            /* webpackChunkName: "invoices-edit" */ "@/views/front/invoices/Edit"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Package",
              to: "Invoices",
            },
            {
              text: "Edit",
            },
          ],
        },
      },
      {
        path: "/invoice/inbound-entries/:id",
        name: "InboundEntries",
        component: () =>
          import(
            /* webpackChunkName: "invoices-inbound" */ "@/views/front/invoices/InboundEntries"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Package",
              to: "Invoices",
            },
            {
              text: "Inbound Entries",
            },
          ],
        },
      },
      {
        path: "/carrier-coverage",
        name: "CarrierCoverage",
        component: () =>
          import(
            /* webpackChunkName: "carrier-coverage" */ "@/views/front/carriers/Coverage"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Carrier Coverage",
            },
          ],
          permissionKey:
            "app_carrier_partner:app_carrier_partner.apis.api_country_services_coverage.CarrierPartnerAPI",
        },
      },
      {
        path: "/country-wise-coverage",
        name: "CountryWiseCoverage",
        component: () =>
          import(
            /* webpackChunkName: "country-wise-coverage" */ "@/views/front/carriers/CountryWiseCoverage"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Country Coverage",
            },
          ],
        },
      },
      {
        path: "/quotes-list",
        name: "QuotesList",
        component: () =>
          import(
            /* webpackChunkName: "invoices-quotes" */ "@/views/front/invoices/QuotesList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Quotes List",
            },
          ],
          permissionKey: "app_seller:freight_list_list_create",
        },
      },
      {
        path: "/city-download",
        name: "CityDownload",
        component: () =>
          import(
            /* webpackChunkName: "invoices-quotes" */ "@/components/front/city/Download"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Download City Coverage",
            },
          ],
          permissionKey: "app_linehaul:client-linehauls-list",
        },
      },
      {
        path: "/pending-payments",
        name: "PendingPayments",
        component: () =>
          import(
            /* webpackChunkName: "pending-payments" */ "@/views/front/invoices/PendingPayments"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Pending Payments",
            },
          ],
          permissionKey: "app_seller:invoice_pending_listing",
        },
      },
      {
        path: "/pending-payments",
        name: "PendingPayments",
        component: () =>
          import(
            /* webpackChunkName: "pending-payments" */ "@/views/front/invoices/PendingPayments"
          ),
        meta: {
          breadcrums: [
            {
              text: "Payment Pending from Seller",
            },
          ],
        },
      },
      {
        path: "/bank-transfer",
        name: "BankTransfer",
        component: () =>
          import(
            /* webpackChunkName: "bank-transfer" */ "@/views/front/invoices/BankTransfer"
          ),
        meta: {
          breadcrums: [
            {
              text: "Bank Transfer",
            },
          ],
          permissionKey: "app_payment_gateway:seller_invoice_list_create",
        },
      },
      {
        path: "/payment-list",
        name: "PaymentList",
        component: () =>
          import(
            /* webpackChunkName: "payment-list" */ "@/views/front/invoices/PaymentList"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "List of Payments",
            },
          ],
          permissionKey: "app_payment_gateway:payment_list_list_create",
        },
      },
      {
        path: "/payment-gateway-status",
        name: "PaymentGatewayStatus",
        component: () =>
          import(
            /* webpackChunkName: "payment-gateway-status" */ "@/views/front/invoices/PaymentGatewayStatus"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Payment Gateway Status",
            },
          ],
          permissionKey: "app_payment_gateway:order_id_list_create",
        },
      },
      {
        path: "/upload-outbound",
        name: "UploadOutbound",
        component: () =>
          import(
            /* webpackChunkName: "outbound" */ "@/views/front/upload-outbound/Index"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Upload Outbound Files",
            },
          ],
          permissionKey: "upload-outbound-files",
        },
      },
      {
        path: "/inbound-list",
        name: "InboundList",
        component: () => import("@/views/front/infor/InboundList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Orders/Receipt",
            },
          ],
        },
      },
      {
        path: "/inbound-transaction",
        name: "InboundTransaction",
        component: () => import("@/views/front/infor/Transaction"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Orders/Receipt",
              to: "InboundList",
            },
            {
              text: "Transaction",
            },
          ],
        },
        props: (route) => ({ id: route.params.id }),
      },
      {
        path: "/inbound-list-summary",
        name: "InboundSummaryList",
        component: () => import("@/views/front/infor/InboundSummaryList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Orders/Receipt Summary",
            },
          ],
        },
      },
      {
        path: "/inbound-summary-goods",
        name: "InboundSummaryGoods",
        component: () => import("@/views/front/infor/InboundGoods"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Received Expiry Goods",
            },
          ],
        },
      },
      {
        path: "/finance-summary",
        name: "Finance",
        component: () => import("@/views/front/finance/Summary"),
        meta: {
          breadcrums: [
            {
              text: "Fiance",
            },
            {
              text: "Summary",
            },
          ],
        },
      },
      {
        path: "/sla-configuration",
        name: "SlaList",
        component: () => import("@/views/front/sla/List"),
        meta: {
          breadcrums: [
            {
              text: "SLA Configuration",
            },
            {
              text: "List",
            },
          ],
        },
      },

      {
        path: "/sla-order-tracking",
        name: "SlaOrderTracking",
        component: () => import("@/views/front/sla/Order"),
        meta: {
          breadcrums: [
            {
              text: "SLA Order Tracking",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/sla-configuration/:id",
        name: "SlaDetails",
        component: () => import("@/views/front/sla/Add"),
        meta: {
          breadcrums: [
            {
              text: "SLA Configuration",
              to: "SlaList",
            },
            {
              text: "Add/Edit",
            },
          ],
        },
      },
      {
        path: "/outbound-list",
        name: "OutboundList",
        component: () => import("@/views/front/infor/OutboundList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Orders",
            },
          ],
        },
      },
      {
        path: "/inbound-summary-view",
        name: "InboundListView",
        component: () => import("@/views/front/infor/InboundSummaryView"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Order",
              to: "InboundList",
            },
            {
              text: "Inbound Order Summary",
            },
          ],
        },
      },
      {
        path: "/outbound-summary-view",
        name: "OutboundListView",
        component: () => import("@/views/front/infor/OutboundSummaryView"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Order",
              to: "OutboundList",
            },
            {
              text: "Outbound Order Summary",
            },
          ],
        },
      },
      {
        path: "/outbound-variant-summary-view",
        name: "OutboundVariantListView",
        component: () => import("@/views/front/infor/OutboundVariantSummary"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Order/Receipt",
            },
            {
              text: "Outbound Variant List",
              to: "OutboundVariantList",
            },
            {
              text: "Outbound Variant Order Summary",
            },
          ],
        },
      },
      {
        path: "/sku-b2b-list",
        name: "SKUB2BList",
        component: () => import("@/views/front/infor/SkuList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/sku-b2b-uploaded-list",
        name: "SKUB2BUploadedList",
        component: () => import("@/views/front/infor/B2bSkuList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU",
            },
          ],
        },
      },
      {
        path: "/sku-b2b-upload",
        name: "SKUB2BListUpload",
        component: () => import("@/views/front/infor/UploadSku"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU",
              to: "SKUB2BUploadedList",
            },
            {
              text: "Upload SKU",
            },
          ],
        },
      },
      {
        path: "/inbound-upload",
        name: "InboundUpload",
        component: () => import("@/views/front/infor/Inbound"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Orders/Receipt",
              to: "InboundList",
            },
            {
              text: "Inbound/Receipt Upload",
            },
          ],
        },
      },
      {
        path: "/inbound-bulk-upload",
        name: "InboundUpload",
        component: () => import("@/views/front/infor/InboundBulk"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Orders/Receipt",
              to: "InboundList",
            },
            {
              text: "Inbound/Receipt Bulk Upload",
            },
          ],
        },
      },
      {
        path: "/outbound-upload",
        name: "OutboundUpload",
        component: () => import("@/views/front/infor/Outbound"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Orders",
              to: "OutboundList",
            },
            {
              text: "Outbound Upload",
            },
          ],
        },
      },
      {
        path: "/outbound-bulk-upload",
        name: "OutboundBulkUpload",
        component: () => import("@/views/front/infor/OutboundBulk"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Orders",
              to: "OutboundList",
            },
            {
              text: "Outbound Bulk Upload",
            },
          ],
        },
      },
      {
        path: "/outbound-Variant",
        name: "OutboundVariantList",
        component: () => import("@/views/front/priceRate/Outbound_List"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
            },
            {
              text: "Outbound Orders/Receipt List",
            },
          ],
        },
      },

      {
        path: "/inbound-Variant",
        name: "PriceRateList",
        component: () => import("@/views/front/priceRate/List"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
            },
            {
              text: "Variant Labelling Status",
            },
          ],
        },
      },
      {
        path: "/add-variant-order/:id",
        name: "addVariantOrder",
        component: () => import("@/views/front/priceRate/AddVariant"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
              to: "InboundSummary",
            },
            {
              text: "Add Variant Orders/Receipt",
            },
          ],
        },
      },
      {
        path: "/add-Outbound-order",
        name: "addOutboundOrder",
        component: () => import("@/views/front/priceRate/AddOutbound"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
              to: "OutboundVariantList",
            },
            {
              text: "Add Outbound Orders/Receipt",
            },
          ],
        },
      },
      {
        path: "/skulist",
        name: "SkuVariantlist",
        component: () => import("@/views/front/priceRate/SkuList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Variant",
            },
            {
              text: "SKU Variant List",
            },
          ],
        },
      },
      {
        path: "/search-sku",
        name: "SkuSearch",
        component: () =>
          import(
            /* webpackChunkName: "UploadProduct" */ `@/views/front/priceRate/SkuSearch`
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Variant",
            },
            {
              text: "Search SKU Variant",
            },
          ],
        },
      },
      {
        path: "/add-edit-sku/:id",
        name: "AddSku",
        component: () => import("@/views/front/priceRate/AddSku"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Variant",
            },
            {
              text: "SKU Variant List",
              to: "SkuVariantlist",
            },
            {
              text: "Add / Edit Sku Variant",
            },
          ],
        },
      },
      {
        path: "/upload-barcode",
        name: "AddSku",
        component: () => import("@/views/front/priceRate/UploadBarcode"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Variant",
            },
            {
              text: "SKU Variant List",
              to: "SkuVariantlist",
            },
            {
              text: "Upload Barcode",
            },
          ],
        },
      },
      {
        path: "/linksku",
        name: "LinkSku",
        component: () => import("@/views/front/priceRate/LinkSku"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Variant",
            },
            {
              text: "Sku Variant Image",
            },
          ],
        },
      },
      {
        path: "/inboundSummary",
        name: "InboundSummary",
        component: () => import("@/views/front/priceRate/Summary"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
            },
            {
              text: "Variant Orders/Receipt List",
            },
          ],
        },
      },
      {
        path: "/inboundSummary",
        name: "InboundSummary",
        component: () => import("@/views/front/priceRate/Summary"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Variant Orders/Receipt",
            },
            {
              text: "Variant Orders/Receipt List",
            },
          ],
        },
      },
      {
        path: "/outbound-xml-data-parsing",
        name: "OutboundXMLDataParsing",
        component: () =>
          import(
            /* webpackChunkName: "outbound-xml-data-parsing" */ "@/views/front/outboundxml/Index"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Outbound XML DataParsing",
            },
          ],
          permissionKey: "app_seller:xml-file-parsing",
        },
      },

      {
        path: "/rsa-xml-invoice",
        name: "ManifestXML",
        component: () =>
          import(
            /* webpackChunkName: "manifest-xml" */ "@/views/front/outboundxml/ManifestXMLListing"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "Outbound XML DataParsing",
              to: "OutboundXMLDataParsing",
            },
            {
              text: "Manifest XML",
            },
          ],
        },
      },
      {
        path: "/rsa-xml-invoice-details/:id",
        name: "ManifestXMLDetails",
        component: () =>
          import(
            /* webpackChunkName: "manifest-xml-details" */ "@/views/front/outboundxml/ManifestXMLDetailsView"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "Manifest XML",
              to: "ManifestXML",
            },
            {
              text: "Manifest XML Details",
            },
          ],
        },
      },
      {
        path: "/obamz-commercial-invoice",
        name: "CommercialInvoiceXML",
        component: () =>
          import(
            /* webpackChunkName: "commercial-invoice-xml" */ "@/views/front/outboundxml/CommercialInvoiceXMLListing"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "Outbound XML DataParsing",
              to: "OutboundXMLDataParsing",
            },
            {
              text: "Commercial Invoice XML",
            },
          ],
        },
      },
      {
        path: "/obamz-commercial-invoice-details/:id",
        name: "CommercialInvoiceXMLDetails",
        component: () =>
          import(
            /* webpackChunkName: "commercial-invoice-xml-details" */ "@/views/front/outboundxml/CommercialInvoiceXMLDetailsView"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "Commercial Invoice XML",
              to: "CommercialInvoiceXML",
            },
            {
              text: "Commercial Invoice XML Details",
            },
          ],
        },
      },
      {
        path: "/hs-code",
        name: "HSCode",
        component: () =>
          import(
            /* webpackChunkName: "hs-code" */ "@/views/front/hs-code/Index"
          ),
        meta: {
          auth: true,
          breadcrums: [
            {
              text: "HS Code",
              to: "HSCode",
            },
          ],
          permissionKey: "search-hs-code",
        },
      },
      {
        path: "/hs-code-list",
        name: "HSCodeList",
        component: () =>
          import(
            /* webpackChunkName: "hs-code-list" */ "@/views/front/hs-code/View"
          ),
        meta: {
          breadcrums: [
            {
              text: "HS Code",
              to: "HSCode",
            },
            {
              text: "HS Code Listing",
            },
          ],
        },
      },
      {
        path: "/add-products",
        name: "Products",
        component: () =>
          import(
            /* webpackChunkName: "sellers-products" */ "@/views/front/sellers/Products"
          ),
        meta: {
          breadcrums: [
            {
              text: "IOR Services",
            },
            {
              text: "Check Product Eligibility",
              to: "Products",
            },
            // {
            //   text: "Add",
            // },
          ],
          permissionKey: "app_seller:product_temp_list",
        },
      },
      {
        path: "/tracking-range",
        name: "TrackingRange",
        component: () =>
          import(
            /* webpackChunkName: "tracking-ranges" */ "@/views/front/tracking-ranges/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Manage Tracking Range",
            },
          ],
        },
      },
      {
        path: "/inbox",
        name: "Inbox",
        component: () =>
          import(/* webpackChunkName: "inbox" */ "@/views/front/inbox/Inbox"),
        meta: {
          breadcrums: [
            {
              text: "Inbox",
            },
          ],
        },
      },
      {
        path: "/inbox/:id",
        name: "InboxView",
        component: () =>
          import(
            /* webpackChunkName: "inbox-view" */ "@/views/front/inbox/View"
          ),
        meta: {
          breadcrums: [
            {
              to: "Inbox",
              text: "Inbox",
            },
            {
              text: "View",
            },
          ],
        },
      },
      {
        path: "/manifests/configuration",
        name: "MnfConfiguration",
        component: () =>
          import(
            /* webpackChunkName: "manifests-config" */ "@/views/front/manifests/Configuration"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Configuration",
            },
          ],
          permissionKey: "app_consolidations:package_column_field",
        },
      },

      {
        path: "/drfLogs",
        name: "DrfLogs",
        component: () =>
          import(
            /* webpackChunkName: "manifests-config" */ "@/views/front/logs/ListView"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "DRF Logs",
            },
          ],
          permissionKey: "rsa_api_logger:log-data",
        },
      },
      {
        path: "/change-password",
        name: "ChangePassword",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/ChangePassword"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Change Password",
            },
          ],
          permissionKey: "change-password",
        },
      },
      {
        path: "/add-edit-configuration/:id",
        name: "AddConfiguration",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/configurationAdd"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Configuration",
              to: "ListConfiguration",
            },
            {
              text: "Add / Edit",
            },
          ],
          permissionKey: "app_encrypt_decrypt:add_configuration",
        },
      },
      {
        path: "/list-configuration",
        name: "ListConfiguration",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/configurationList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Configuration",
            },
          ],
          permissionKey: "app_encrypt_decrypt:configuration_list",
        },
      },
      {
        path: "/country-settings",
        name: "CountrySettings",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/CountrySettings"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Country Settings",
            },
          ],
        },
      },
      {
        path: "/city-settings/:id/:code",
        name: "CitySettings",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/citySetting"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            { text: "Country Settings", to: "CountrySettings" },
            {
              text: "City Settings",
            },
          ],
        },
      },
      {
        path: "/upload-pincode",
        name: "uploadPincode",
        component: () => import("@/views/front/home/UploadPincode"),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Country Settings",
              to: "CountrySettings",
            },
            {
              text: "Upload Pincode",
            },
          ],
        },
      },
      {
        path: "/country/:id",
        name: "hscode",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/hscode"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Country Settings",
              to: "CountrySettings",
            },
            {
              text: "Edit",
            },
          ],
        },
      },
      {
        path: "/upload-area/:id",
        name: "uploadArea",
        component: () =>
          import(
            /* webpackChunkName: "change-password" */ "@/views/front/home/UploadArea"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Country Settings",
              to: "CountrySettings",
            },
            {
              text: "Upload Area",
            },
          ],
        },
      },
      {
        path: "bags",
        component: () =>
          import(/* webpackChunkName: "bags" */ "@/views/front/bags/Index"),
        children: [
          {
            path: "",
            component: () =>
              import(
                /* webpackChunkName: "bag-list" */ "@/components/front/bags/List"
              ),
            name: "BagsList",
            meta: {
              breadcrums: [
                {
                  text: "Bags",
                },
              ],
            },
          },
          {
            path: "bags-template",
            component: () =>
              import(
                /* webpackChunkName: "bag-template" */ "@/components/front/bags/Template"
              ),
            name: "BagsTemplate",
            meta: {
              breadcrums: [
                {
                  text: "Bags",
                  to: "BagsList",
                },
                {
                  text: "Explain Template",
                },
              ],
            },
          },
        ],
      },
      {
        path: "bags/:id",
        component: () =>
          import(
            /* webpackChunkName: "bag-details" */ "@/views/front/bags/Details"
          ),
        name: "BagDetails",
        meta: {
          breadcrums: [
            {
              text: "Bags",
              to: "BagsList",
            },
            {
              text: "Edit",
            },
          ],
        },
      },
      {
        path: "packages",
        component: () => import("@/views/front/packages/Index"),
        children: [
          {
            path: "",
            component: () => import("@/components/front/packages/List"),
            name: "PackagesList",
            meta: {
              breadcrums: [
                {
                  text: "Lastmile Delivery",
                },
                {
                  text: "Upload Package",
                },
              ],
              permissionKey: "app_consignment_order:consignment_list",
            },
          },
          {
            path: "/pastOrder",
            component: () =>
              import(
                /* webpackChunkName: "packages-list" */ "@/components/front/packages/ListOld"
              ),
            name: "PackagesListOld",
            meta: {
              breadcrums: [
                {
                  text: "Lastmile Delivery",
                },
                {
                  text: "Update Offline data",
                },
              ],
              permissionKey:
                "app_consignment_order:lastmile-missing-oldpackage-upload",
            },
          },
          {
            path: "packages-template",
            component: () =>
              import(
                /* webpackChunkName: "packages-template" */ "@/components/front/packages/Template"
              ),
            name: "PackagesTemplate",
            meta: {
              breadcrums: [
                {
                  text: "Packages",
                  to: "PackagesList",
                },
                {
                  text: "Explain Template",
                },
              ],
            },
          },
        ],
      },
      {
        path: "packages/:id",
        component: () =>
          import(
            /* webpackChunkName: "packages-details" */ "@/views/front/packages/Details"
          ),
        name: "PackageDetails",
        meta: {
          breadcrums: [
            {
              text: "Packages",
              to: "PackagesList",
            },
            {
              text: "Edit",
            },
          ],
        },
      },
      {
        path: "consolidations",
        component: () =>
          import(
            /* webpackChunkName: "consolidations" */ "@/views/front/consolidations/Index"
          ),
        name: "Consolidations",
        meta: {
          breadcrums: [
            {
              text: "Consolidations",
              to: "Consolidations",
            },
            {
              text: "View",
            },
          ],
        },
      },
      {
        path: "consolidations/:id",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-details" */ "@/views/front/consolidations/Details"
          ),
        name: "ConsolidationsDetails",
        meta: {
          breadcrums: [
            {
              text: "Consolidations",
              to: "Consolidations",
            },
            {
              text: "Create",
            },
          ],
        },
      },
      {
        path: "new-consolidations",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-new" */ "@/views/front/consolidations/New"
          ),
        name: "NewConsolidations",
        meta: {
          breadcrums: [
            {
              text: "Inbound",
            },
            {
              text: "New Consolidations",
            },
          ],
        },
      },
      {
        path: "new-consolidations/deconsolidated",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-deconsolidated" */ "@/views/front/consolidations/Deconsolidated"
          ),
        name: "Deconsolidated",
        meta: {
          auth: false,
          breadcrums: [
            {
              text: "Inbound",
            },
            {
              text: "Deconsolidated",
            },
          ],
        },
      },
      {
        path: "new-consolidations/merged",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-merged" */ "@/views/front/consolidations/Merged"
          ),
        name: "Merged",
        meta: {
          breadcrums: [
            {
              text: "Inbound",
            },
            {
              text: "Merged",
            },
          ],
        },
      },
      {
        path: "new-consolidations/staged",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-staged" */ "@/views/front/consolidations/Staged"
          ),
        name: "Staged",
        meta: {
          breadcrums: [
            {
              text: "Outbound",
            },
            {
              text: "Staged",
            },
          ],
        },
      },
      {
        path: "new-consolidations/dispatched",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-dispatched" */ "@/views/front/consolidations/Dispatched"
          ),
        name: "Dispatched",
        meta: {
          breadcrums: [
            {
              text: "Outbound",
            },
            {
              text: "Dispatched",
            },
          ],
        },
      },
      {
        path: "new-consolidations/departed",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-departed" */ "@/views/front/consolidations/Departed"
          ),
        name: "Departed",
        meta: {
          breadcrums: [
            {
              text: "Outbound",
            },
            {
              text: "Departed",
            },
          ],
        },
      },
      {
        path: "lm-new-inbound",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-lm-new" */ "@/views/front/consolidations/LMNew"
          ),
        name: "LMNewConsolidations",
        meta: {
          breadcrums: [
            {
              text: "Inbound",
            },
            {
              text: "New",
            },
          ],
        },
      },
      {
        path: "lm-apply-scan",
        component: () =>
          import(
            /* webpackChunkName: "scanning-lm-apply-scan" */ "@/views/front/scanning/LMApplyScan"
          ),
        name: "LMApplyScan",
        meta: {
          breadcrums: [
            {
              text: "Scanning",
            },
            {
              text: "Apply Scan",
            },
          ],
        },
      },
      {
        path: "lm-scan-upload",
        component: () =>
          import(
            /* webpackChunkName: "scanning-lm-scan-upload" */ "@/views/front/scanning/LMScanUpload"
          ),
        children: [
          {
            path: "",
            component: () =>
              import(
                /* webpackChunkName: "scanning-lm-scan-upload-list" */ "@/components/front/scanning/LMScanUploadList"
              ),
            name: "LMScanUploadList",
            meta: {
              breadcrums: [
                {
                  text: "Scanning",
                },
                {
                  text: "Bulk Scan Upload",
                },
              ],
            },
          },
          {
            path: "lm-scan-upload-template",
            component: () =>
              import(
                /* webpackChunkName: "scanning-lm-scan-upload-template" */ "@/components/front/scanning/LMScanUploadTemplate"
              ),
            name: "LMScanUploadTemplate",
            meta: {
              breadcrums: [
                {
                  text: "Bulk Scan Upload",
                  to: "LMScanUploadList",
                },
                {
                  text: "Explain Template",
                },
              ],
            },
          },
        ],
      },
      {
        path: "lm-in-clearance",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-lm-in-clearence" */ "@/views/front/consolidations/LMInClearance"
          ),
        name: "LMInClearance",
        meta: {
          breadcrums: [
            {
              text: "Inbound",
            },
            {
              text: "In Clearance",
            },
          ],
        },
      },
      {
        path: "lm-missing-scan",
        component: () =>
          import(
            /* webpackChunkName: "scanning-lm-missing-scan" */ "@/views/front/scanning/LMMissingScan"
          ),
        name: "LMMissingScan",
        meta: {
          breadcrums: [
            {
              text: "Scanning",
            },
            {
              text: "Missing Scan",
            },
          ],
        },
      },
      {
        path: "/client/tracking",
        name: "ClientTracking",
        component: () =>
          import(
            /* webpackChunkName: "client-tracking" */ "@/views/front/tracking/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Tracking",
            },
          ],
        },
      },
      {
        path: "/tracking",
        name: "Tracking",
        component: () =>
          import(
            /* webpackChunkName: "client-tracking" */ "@/components/front/tracking/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Track Shipment",
            },
          ],
          permissionKey: "app_client:tracking_details",
        },
      },
      {
        path: "/pudo-list",
        name: "PudoList",
        component: () =>
          import(
            /* webpackChunkName: "carriers" */ "@/views/front/carriers/Pudo.vue"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Pudo List",
            },
          ],
          permissionKey: "app_carrier_partner:carrier_pudo_list",
        },
      },
      {
        path: "/pudo-search",
        name: "PudoSearch",
        component: () =>
          import(
            /* webpackChunkName: "carriers" */ "@/views/front/carriers/PudoSearch.vue"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Pudo List",
            },
          ],
          permissionKey: "app_carrier_partner:carrier_pudo_list",
        },
      },
      {
        path: "/client/tracking/summary",
        name: "ClientTrackingSummary",
        component: () =>
          import(
            /* webpackChunkName: "client-tracking-summary" */ "@/views/front/tracking/Summary"
          ),
        meta: {
          breadcrums: [
            {
              text: "Tracking",
              to: "ClientTracking",
            },
            {
              text: "Summary",
            },
          ],
        },
      },
      {
        path: "/client/tracking/details",
        name: "ClientTrackingDetails",
        component: () =>
          import(
            /* webpackChunkName: "client-tracking-details" */ "@/views/front/tracking/Details"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },

            {
              text: "Track Shipment",
              to: "Tracking",
            },
            {
              text: "Tracking",
            },
          ],
        },
      },
      {
        path: "/client-addresses",
        name: "ClientAddresses",
        component: () =>
          import(
            /* webpackChunkName: "client-addresses" */ "@/views/front/client-addresses/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "Client Address(es)",
            },
          ],
          permissionKey: "app_client:client_address_list",
        },
      },
      {
        path: "/client-token",
        name: "ClientToken",
        component: () =>
          import(
            /* webpackChunkName: "client-addresses" */ "@/views/front/client-Token/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "API token for Clients",
            },
          ],
          permissionKey: "app_client:client_generate_token_list",
        },
      },

      {
        path: "/carrier-settings",
        name: "CarrierSettings",
        component: () => import("@/views/front/carrier-Setting/Index"),
        meta: {
          breadcrums: [
            {
              text: "Carriers",
              to: "Carriers",
            },
            {
              text: "Carrier Settings",
            },
          ],
        },
      },
      {
        path: "/client-settings",
        name: "ClientSettings",
        component: () =>
          import(
            /* webpackChunkName: "client-addresses" */ "@/views/front/client-Setting/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
              to: "Clients",
            },
            {
              text: "Client Settings",
            },
          ],
        },
      },
      {
        path: "/client-addresses/:id",
        name: "ClientAddressDetails",
        component: () =>
          import(
            /* webpackChunkName: "client-addresses-details" */ "@/views/front/client-addresses/Details"
          ),
        meta: {
          breadcrums: [
            {
              text: "Addresses",
              to: "ClientAddresses",
            },
            {
              text: "Details",
            },
          ],
        },
      },
      {
        path: "/client/subscription/tracking",
        name: "TrackLblSub",
        component: () =>
          import(
            /* webpackChunkName: "tracking-subscription" */ "@/views/front/tracking-subscription/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Subscription",
            },
          ],
          permissionKey: "app_sub_accounts:user_sub_user_api_list_create",
        },
      },
      {
        path: "/client/consolidations/manifest/download",
        name: "ManifestDownload",
        component: () =>
          import(
            /* webpackChunkName: "consolidations-manifest-download" */ "@/views/front/consolidations/ManifestDownload"
          ),
        meta: {
          breadcrums: [
            {
              text: "Manifest",
              to: "ManifestDownload",
            },
            {
              text: "Download",
            },
          ],
        },
      },
      {
        path: "/access-control",
        component: () =>
          import(
            /* webpackChunkName: "user-groups" */ "@/views/front/user-groups/Index"
          ),
        children: [
          {
            path: "users/list",
            component: () =>
              import(
                /* webpackChunkName: "user-groups-users" */ "@/components/front/user-groups/Users"
              ),
            name: "UsersList",
            meta: {
              breadcrums: [
                {
                  text: "Settings",
                },
                {
                  text: "Users",
                },
              ],
              permissionKey: "app_sub_accounts:user_sub_user_api_list_create",
            },
          },
          {
            path: "users/details/:id",
            component: () =>
              import(
                /* webpackChunkName: "user-groups-user-create" */ "@/components/front/user-groups/UserCreate"
              ),
            name: "UserCreate",
            meta: {
              breadcrums: [
                {
                  text: "Settings",
                },
                {
                  text: "Users",
                  to: "UsersList",
                },
                {
                  text: "Create users",
                },
              ],
            },
          },
          {
            path: "groups/list",
            component: () =>
              import(
                /* webpackChunkName: "user-groups-groups" */ "@/components/front/user-groups/Groups"
              ),
            name: "GroupsList",
            meta: {
              breadcrums: [
                {
                  text: "Settings",
                },
                {
                  text: "User groups",
                },
              ],
            },
          },
          {
            path: "groups/details/:id",
            component: () =>
              import(
                /* webpackChunkName: "user-groups-group-create" */ "@/components/front/user-groups/GroupCreate"
              ),
            name: "GroupCreate",
            meta: {
              breadcrums: [
                {
                  text: "Settings",
                },
                {
                  text: "Groups",
                  to: "GroupsList",
                },
                {
                  text: "Create groups",
                },
              ],
            },
          },
          {
            path: "screens/list",
            component: () =>
              import(
                /* webpackChunkName: "user-groups-users" */ "@/components/front/user-groups/UserCategoryScreen"
              ),
            name: "UserCategoryScreen",
            meta: {
              breadcrums: [
                {
                  text: "Settings",
                },
                {
                  text: "User Screen",
                },
              ],
            },
          },
        ],
      },
      {
        path: "/set-alerts",
        name: "SetAlerts",
        component: () =>
          import(
            /* webpackChunkName: "alerts" */ "@/views/front/alerts/SetAlerts"
          ),
        meta: {
          breadcrums: [
            {
              text: "Settings",
            },
            {
              text: "Set Alerts",
            },
          ],
        },
      },
      {
        path: "sellers",
        component: () =>
          import(
            /* webpackChunkName: "sellers" */ "@/views/front/sellers/Index"
          ),
        children: [
          {
            path: "",
            component: () =>
              import(
                /* webpackChunkName: "sellers-list" */ "@/components/front/sellers/List"
              ),
            name: "SellersList",
            meta: {
              breadcrums: [
                {
                  text: "IOR Services",
                },
                {
                  text: "Upload Seller List",
                },
              ],
              permissionKey: "app_seller:seller_upload_list_list_create",
            },
          },
          {
            path: "sellers-template",
            component: () =>
              import(
                /* webpackChunkName: "sellers-template" */ "@/components/front/sellers/Template"
              ),
            name: "SellersTemplate",
            meta: {
              breadcrums: [
                {
                  text: "Sellers",
                  to: "SellersList",
                },
                {
                  text: "Explain Template",
                },
              ],
            },
          },
        ],
      },
      {
        path: "/manage-sellers",
        name: "ManageSellers",
        component: () =>
          import(
            /* webpackChunkName: "manage-sellers" */ "@/views/front/sellers/ManageSellers"
          ),
        meta: {
          breadcrums: [
            {
              text: "Manage Sellers",
            },
          ],
          permissionKey: "app_seller:manage_seller",
        },
      },
      {
        path: "/transport",
        name: "Transport",
        component: () =>
          import(
            /* webpackChunkName: "manage-sellers" */ "@/components/front/Transport/List"
          ),
        meta: {
          breadcrums: [
            {
              text: "Transport",
            },
          ],
          permissionKey: "app_clickrf:dow_view_orders",
        },
      },
      {
        path: "/rsaservices",
        name: "Rsaservices",
        component: () => import("@/components/front/services"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },

            {
              text: "RSA Services",
            },
          ],
          permissionKey: "app_service_type:rsa_service_types_list",
        },
      },
      {
        path: "/rsaservices/:id",
        name: "AddRsaServices",
        component: () => import("@/components/front/addRsaServices"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },

            {
              text: "RSA Services",
              to: "Rsaservices",
            },
            {
              text: "Add / Edit",
            },
          ],
          permissionKey: "app_service_types:rsa_service_types",
        },
      },
      {
        path: "/vendor",
        name: "Vendor",
        component: () => import("@/components/front/Vendor/List"),
        meta: {
          breadcrums: [
            {
              text: "Vendor",
            },
          ],
          permissionKey: "app_ecom_vendors:vendor_list",
        },
      },
      {
        path: "/vendor/:id",
        name: "vendorDetails",
        component: () => import(`@/components/front/Vendor/Details`),
        meta: {
          breadcrums: [
            {
              text: "Vendor",
              to: "Vendor",
            },
            {
              text: "Add or Edit",
            },
          ],
        },
      },
      {
        path: "/download-reports",
        component: () =>
          import(
            /* webpackChunkName: "user-groups-users" */ "@/components/front/download-interface/Reports"
          ),
        name: "Download",
        meta: {
          breadcrums: [
            {
              text: "Download",
            },
          ],
          permissionKey: "app_report_export:er-last-mile",
        },
      },
      {
        path: "/shipping-list",
        name: "OrderList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Fulfillment Shiping List",
            },
          ],
          permissionKey: "app_ecom_vendors:aev__fulfillment_order_list",
        },
      },
      {
        path: "/orderList",
        name: "OrdersList",
        component: () => import("@/views/front/order/OrdersList"),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Order List",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_sale_order_list",
        },
      },
      {
        path: "/order-upload",
        name: "UploadOrder",
        component: () =>
          import(
            /* webpackChunkName: "upload-order" */ "@/views/front/order/Upload"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Upload Order",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_order_upload",
        },
      },

      {
        path: "/channel-mapping",
        name: "clientChannelMapping",
        component: () =>
          import(
            /* webpackChunkName: "MappingOms" */ "@/views/front/oms/channel"
          ),
        meta: {
          breadcrums: [
            {
              text: "Clients",
            },
            {
              text: "Mapping Oms Channel",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_client_channel_list",
        },
      },
      {
        path: "/mapping-list",
        name: "MappingOms",
        component: () =>
          import(/* webpackChunkName: "MappingOms" */ "@/views/front/oms/List"),
        meta: {
          breadcrums: [
            {
              text: "Clients",
            },
            {
              text: "Mapping OMS",
            },
          ],
          permissionKey: "app_ecom_vendors:oms_client_mapping_list",
        },
      },
      {
        path: "/shipment-summary",
        name: "shipmentSummary",
        component: () =>
          import(
            /* webpackChunkName: "oms-screen-list" */ "@/views/front/summary/List"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Shipment summary",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_order_track_count",
        },
      },
      {
        path: "/order-summary",
        name: "ordersSummary",
        component: () => import("@/views/front/summary/order"),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Order summary",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_sale_order_count_track",
        },
      },
      {
        path: "/package-error-list",
        name: "PackageErrorlist",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/PackageError"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Upload Package",
            },
            {
              text: "Error List",
            },
          ],
        },
      },
      {
        path: "/outbound-error-list",
        name: "OutboundErrorlist",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/OutboundError"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Bulk Order",
            },
            {
              text: "Error List",
            },
          ],
        },
      },
      {
        path: "/inbound-error-list",
        name: "InboundErrorlist",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/InboundError"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Bulk Order",
            },
            {
              text: "Error List",
            },
          ],
        },
      },
      {
        path: "/uploaded-list",
        name: "orderStatus",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/List"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/order-status-list",
        name: "orderStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/OrderList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Upload Order",
            },
            {
              text: "List",
            },
          ],
        },
      },

      {
        path: "/b2b-sku-status-list",
        name: "skuBBStatusList",
        component: () => import("@/views/front/order/SkuB2BList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/inbound-order-status-list",
        name: "inboundorderStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/InboundOrderList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inbound Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/inbound-bulk-order-status-list",
        name: "inboundBulkorderStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/InboundBulkOrderList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inbound Bulk Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/inbound-bulk-order-list",
        name: "inboundBulkorderList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/InboundBulkOrdersList"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Bulk Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/outbound-variant-order-status-list",
        name: "outboundordervariantStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/OutoundOrderVariantList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Outbound Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/inbound-variant-status-list",
        name: "skuvariantStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/SkuVariantList"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inbound Variant",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/outbound-order-status-list",
        name: "outboundorderStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/OutboundOrderList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Outbound Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/outbound-bulk-order-status-list",
        name: "outboundBulkorderStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/OutboundBulkOrderList"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Bulk Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/outbound-bulk-orders-status-list",
        name: "outboundBulkordersStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/OutboundComb"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Outbound Order",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/package-status-list",
        name: "packageStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/PackageList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },

            {
              text: "Upload Package",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/channel-status-list",
        name: "channelStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/ChannelList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },

            {
              text: "Channel Sku Mapping",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/product-status-list",
        name: "productStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/ProductList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Product/ASN",
            },
            {
              text: "Upload Product",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/sku-status-list",
        name: "skuStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/SkuList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/sku-mapping-status-list",
        name: "skuMappingStatusList",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/SkuMappingList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/hvlv",
        name: "HvLvListing",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/hvLv.vue"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Hv Lv List",
            },
          ],
          permissionKey: "app_ecom_vendors:id_list_create",
        },
      },
      {
        path: "/oms-category-screen",
        name: "OMSScreen",
        component: () =>
          import(
            /* webpackChunkName: "oms-screen-list" */ "@/views/front/omsScreen/List"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "OMS Category Screen",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment_sku_category",
        },
      },
      {
        path: "/channel",
        name: "Channel",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/channel/client"),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Channel Sku Mapping",
            },
          ],
          permissionKey: "fulfillment_channel_sku_mapping",
        },
      },

      {
        path: "/b2binventory",
        name: "B2binventory",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/B2binventory/List"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inventory",
            },
          ],
          permissionKey: "app_infor:b2b_infor_v1_inventory",
        },
      },
      {
        path: "/b2binventorySummary",
        name: "B2binventorySummary",
        component: () =>
          import(
            /* webpackChunkName: "" */ "@/views/front/B2binventory/Summary"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inventory Summary",
            },
          ],
          permissionKey: "app_infor:b2b_infor_v1_inventory",
        },
      },
      {
        path: "/b2binventorySummaryExpiry",
        name: "B2binventorySummaryExpiry",
        component: () =>
          import(
            /* webpackChunkName: "" */ "@/views/front/B2binventory/Expiry"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Inventory Item Summary Expiry",
            },
          ],
          permissionKey: "app_infor:b2b_infor_v1_inventory",
        },
      },

      {
        path: "/asnlist",
        name: "ASNList",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/ASN/AsnList"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "ASN Reopen",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_infor:b2b_inbound_asn_reopen_list",
        },
      },

      {
        path: "/addrequest/:id",
        name: "AddASN",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/ASN/Add"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "ASN Reopen",
              to: "ASNList",
            },
            {
              text: "Request",
            },
          ],
          permissionKey: "app_infor:b2b_inbound_asn_reopen_create",
        },
      },
      {
        path: "/edit-request",
        name: "EditASN",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/ASN/Edit"),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "ASN Reopen",
              to: "ASNList",
            },
            {
              text: "Approval",
            },
          ],
          permissionKey: "app_infor:b2b_inbound_asn_reopen_create",
        },
      },
      {
        path: "/inventory",
        name: "Inventory",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/inventory/List"),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inventory",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment-inventory-snapshot-list",
        },
      },
      {
        path: "/inventoryledger",
        name: "InventoryLedgerList",
        component: () =>
          import(
            /* webpackChunkName: "" */ "@/views/front/inventory/inventoryLedgerList"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Inventory ledger",
            },
          ],
          permissionKey: "app_ecom_vendors:fulfillment-inventory-ledger-list",
        },
      },
      {
        path: "/shelfwise",
        name: "shelfwiseLedgerList",
        component: () =>
          import(
            /* webpackChunkName: "" */ "@/views/front/inventory/shelfwise"
          ),
        meta: {
          breadcrums: [
            {
              text: "Fulfillment",
            },
            {
              text: "Shelfwise",
            },
          ],
          permissionKey:
            "app_ecom_vendors:fulfillment-inventory-shelfwise-list",
        },
      },
      {
        path: "/preAlert",
        name: "PreAlert",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/perAlert/List"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "PreAlert",
            },
          ],
          permissionKey: "app_manifest:pre_alerts_shipment_list",
        },
      },
      {
        path: "/addPreAlert",
        name: "AddPreAlert",
        component: () =>
          import(/* webpackChunkName: "" */ "@/views/front/perAlert/Add"),
        meta: {
          breadcrums: [
            {
              text: "Lastmile Delivery",
            },
            {
              text: "Add  PreAlert Manifest",
            },
          ],
          permissionKey: "app_manifest:pre_alerts_upload",
        },
      },
      {
        path: "/documents",
        name: "Documents",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/documents/Index"
          ),
        meta: {
          breadcrums: [
            {
              text: "Documents",
            },
          ],
        },
      },
      {
        path: "/pas/createToken",
        name: "PasHome",
        component: () =>
          import(
            /* webpackChunkName: "home" */ `@/views/front/pas/createToken`
          ),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Create Token",
            },
          ],
          permissionKey: "app_pas:pas_gate_token_create",
        },
      },
      {
        path: "/pas/dashboard",
        name: "PasDashboard",
        component: () =>
          import(/* webpackChunkName: "home" */ `@/views/front/pas/dashboard`),
      },
      {
        path: "/pas/gateIn",
        name: "PasGateIn",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/gateIn`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Gate In",
            },
          ],
          permissionKey: "app_pas:security_gate_in_out",
        },
      },
      {
        path: "/pas/driverfeedback/:id_token?",
        name: "driverFeedback",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/feedback`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Driver Feedback",
            },
          ],
          permissionKey: "app_pas:security_gate_in_out",
        },
      },

      {
        path: "/pas/gateOut",
        name: "PasGateOut",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/gateOut`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Gate Out",
            },
          ],
          permissionKey: "app_pas:security_gate_in_out",
        },
      },
      {
        path: "/pas/dockIn",
        name: "PasDockIn",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/dockIn`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Dock In",
            },
          ],
          permissionKey: "app_pas:warehouse_dock_in_out",
        },
      },
      {
        path: "/pas/dockOut",
        name: "PasDockOut",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/dockOut`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Dock Out",
            },
          ],
          permissionKey: "app_pas:warehouse_dock_in_out",
        },
      },
      {
        path: "/pas/searchToken",
        name: "PasSearchToken",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/search`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Search Token",
            },
          ],
          permissionKey: "app_pas:pas_search_token",
        },
      },
      {
        path: "/pasList",
        name: "pasList",
        component: () =>
          import(/* webpackChunkName: "pas" */ `@/views/front/pas/list`),
        meta: {
          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "List",
            },
          ],
          permissionKey: "app_pas:pas_gate_token_get",
        },
      },
      {
        path: "/pas/driverDeclaration",
        name: "PasDriver",
        component: () =>
          import(
            /* webpackChunkName: "home" */ `@/views/front/pas/driverDeclaration`
          ),
        meta: {
          auth: true,

          breadcrums: [
            {
              text: "PAS",
            },
            {
              text: "Token Generate",
            },
            {
              text: "Driver Declaration",
            },
          ],
        },
      },

      {
        path: "doc-details/:id",
        component: () => import("@/components/front/service-center/add"),
        name: "AddServieCenter",
        meta: {
          breadcrums: [
            {
              text: "Service Center",
            },
            {
              text: "Document List",
              to: "ServieCenterList",
            },
            {
              text: "Add / Edit",
            },
          ],
        },
      },
      {
        path: "doc-list",
        component: () => import("@/components/front/service-center/list"),
        name: "ServieCenterList",
        meta: {
          breadcrums: [
            {
              text: "Service Center",
            },
            {
              text: "Document List",
            },
          ],
        },
      },
      {
        path: "/barcode-status-list",
        name: "barcodeStatusList",
        component: () =>
          import(
            /* webpackChunkName: "inbound-order-list" */ "@/views/front/order/BarcodeList"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "SKU Barcode",
            },
            {
              text: "List",
            },
          ],
        },
      },
      {
        path: "/barcode-error-list",
        name: "BarcodeErrorlist",
        component: () =>
          import(
            /* webpackChunkName: "order-list" */ "@/views/front/order/BarcodeError"
          ),
        meta: {
          breadcrums: [
            {
              text: "B2B Fulfillment",
            },
            {
              text: "Barcode Uploaded",
            },
            {
              text: "Error List",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/front/Login"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/",
    component: () => import("@/views/front/maintenance.vue"),
    name: "Maintenance",
    meta: {
      auth: false,
    },
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: () =>
      import(/* webpackChunkName: "signup" */ "@/views/front/SignUp"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "@/views/front/ForgotPassword"
      ),
    meta: {
      auth: false,
    },
  },
  {
    path: "/password-reset",
    name: "ResetPassword",
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "@/views/front/ResetPassword"
      ),
    meta: {
      auth: false,
    },
  },

  // {
  //   path: "/tracking",
  //   name: "Tracking",
  //   component: () =>
  //     import(/* webpackChunkName: "tracking" */ "@/views/front/Tracking"),
  //   meta: {
  //     auth: false,
  //   },
  // },
  {
    path: "/tracking/summary",
    name: "TrackingSummary",
    component: () =>
      import(
        /* webpackChunkName: "tracking-summary" */ "@/views/front/TrackingSummary"
      ),
    meta: {
      auth: false,
    },
  },
  {
    path: "/payment-route/:invoicePg/:invoiceNo",
    name: "PaymentRequest",
    component: () =>
      import(
        /* webpackChunkName: "payment-request" */ "@/views/front/payment-request/Index.vue"
      ),
    meta: {
      auth: false,
    },
  },
  {
    path: "/payment-route-response/:invoicePgResponse/:hashValue",
    name: "PaymentResponse",
    component: () =>
      import(
        /* webpackChunkName: "payment-response" */ "@/views/front/payment-response/Index.vue"
      ),
    meta: {
      auth: false,
    },
  },
];
